"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _KatalMetricsDriver2 = _interopRequireDefault(require("./KatalMetricsDriver"));

var _ErrorHandler = require("./ErrorHandler");

var _KatalMetricObject = _interopRequireDefault(require("../metricObject/KatalMetricObject"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Logs metrics to the console.
 *
 * Mainly useful for development and experimentation.
 */
var KatalMetricsDriverConsoleLogJson = /*#__PURE__*/function (_KatalMetricsDriver) {
  (0, _inherits2.default)(KatalMetricsDriverConsoleLogJson, _KatalMetricsDriver);

  var _super = _createSuper(KatalMetricsDriverConsoleLogJson);

  /**
   * Create a new console metrics logger.
   *
   * @param logConsole Console (or console-like object) to log metrics to
   * @param errorHandler Callback in case of error
   */
  function KatalMetricsDriverConsoleLogJson() {
    var _this;

    var logConsole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : console;
    var errorHandler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _ErrorHandler.DEFAULT_ERROR_HANDLER;
    (0, _classCallCheck2.default)(this, KatalMetricsDriverConsoleLogJson);
    _this = _super.call(this);
    _this._errorHandler = errorHandler;
    _this._console = logConsole;
    return _this;
  }

  (0, _createClass2.default)(KatalMetricsDriverConsoleLogJson, [{
    key: "errorHandler",
    get: function get() {
      return this._errorHandler;
    } // TODO: errorHandler in this method is deprecated and will be removed.

  }, {
    key: "publish",
    value: function publish(metricObject, errorHandler, context) {
      var fields = _objectSpread({}, context.getFields());

      switch (metricObject.type) {
        case _KatalMetricObject.default.Types.String:
        case _KatalMetricObject.default.Types.Counter:
        case _KatalMetricObject.default.Types.Timer:
          (0, _extends2.default)(fields, {
            type: metricObject.type,
            metricKey: metricObject.name,
            value: metricObject.value
          });

          if (metricObject.isMonitor) {
            fields.isMonitor = true;
          }

          break;

        default:
          var err = new Error("Unknown type ".concat(metricObject.type, " when publishing metric object."));
          this.errorHandler(err);
          return;
      }

      this._console.log(fields);
    }
  }]);
  return KatalMetricsDriverConsoleLogJson;
}(_KatalMetricsDriver2.default);

exports.default = KatalMetricsDriverConsoleLogJson;